import React from "react";

export function AdditionalInputPage({parameter, setParameter, confirmOTP}){

    return(
        <div className="oauth-login-div d-flex justify-content-center">
            <form className="oauth-login-form" onSubmit={(ev)=>confirmOTP(ev)}>
                <p className="text-center oauth-login-description">
                  We need more information from you. 
                </p>
                <p className="login-label"><strong>{parameter}</strong></p>
                <input required className="oauth-form-control login-field" type={parameter === 'Member Number' ? "number" : "date"} onChange={(ev)=>setParameter(ev.target.value)} />
                <button className="form-btn btn btn-primary" type="submit">NEXT</button>
              </form>
        </div>
    );
}